// Copyright ©️ 2026 eVolve MEP, LLC

import { useMemo } from 'react';

import { Text } from '@mantine/core';

import { convertInchesToImperialString } from 'helpers/convertInchesToImperialString';
import { isNotNil } from 'helpers/isNotNil';
import { useBendTypes } from 'modules/Shop/EvolveFabrication/BendCreator/useBendTypes';

import type { CartBend } from '../Context/useBendCreatorCartContext';
import type { BendCreatorFormValues } from '../Context/useBendCreatorFormContext';

export const BendDimensions = ({ bend }: { bend: BendCreatorFormValues | CartBend }) => {
  const { bendTypes } = useBendTypes();

  const bendType = useMemo(() => bendTypes?.find(({ name }) => name === bend.bendType), [bend, bendTypes]);

  const dimensions = useMemo(
    () =>
      bendType?.inputs
        .map(({ name, keyName, isAngle }) => {
          const value = bend[keyName];
          return {
            keyName,
            text:
              value !== null
                ? `${name} ${isAngle ? `${value.toFixed(2)}°` : convertInchesToImperialString(value * 12)}`
                : null,
          };
        })
        .filter(({ text }) => isNotNil(text)) ?? [],
    [bend, bendType],
  );
  return dimensions.map(({ keyName, text }) => (
    <Text key={keyName} span>
      {text}
    </Text>
  ));
};
